import { render, staticRenderFns } from "./AppBaseView.vue?vue&type=template&id=b6b21680&scoped=true&"
import script from "./AppBaseView.vue?vue&type=script&lang=js&"
export * from "./AppBaseView.vue?vue&type=script&lang=js&"
import style0 from "./AppBaseView.vue?vue&type=style&index=0&id=b6b21680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b21680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6b21680')) {
      api.createRecord('b6b21680', component.options)
    } else {
      api.reload('b6b21680', component.options)
    }
    module.hot.accept("./AppBaseView.vue?vue&type=template&id=b6b21680&scoped=true&", function () {
      api.rerender('b6b21680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app-views/AppBaseView.vue"
export default component.exports